export enum StatusAccodionEnum {
  FINALIZADO = 'FINALIZADO',
  PENDENTE = 'PENDENTE',
  EM_ANDAMENTO = 'EM_ANDAMENTO',
}
